import { Api } from '@/enums/api';
import type { FormTemplate } from '@/modules/rie/types/formTemplate';
import type { CreateFormTemplateRequest } from '@/modules/rie/types/requests/formTemplates/createFormTemplateRequest';
import { callApi } from '@/utils/api';
import { handleAxiosError } from '@/utils/error';
import toast from '@/utils/toast';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const baseUrl = 'FormTemplates';

export const useFormTemplateStore = defineStore('formTemplate', () => {
    const formTemplates = ref<FormTemplate[]>([]);
    const currentFormTemplate = ref<FormTemplate | null>(null);

    async function getAll() {
        try {
            formTemplates.value = await callApi<FormTemplate[]>({ method: 'GET', endpoint: baseUrl, api: Api.IncontrolV2 });
            return formTemplates.value;
        } catch (error) {
            return handleAxiosError(error, [], 'Vragenlijst sjablonen konden niet opgehaald worden');
        }
    }

    async function create(request: CreateFormTemplateRequest) {
        try {
            const data = await callApi<FormTemplate>({ method: 'POST', endpoint: baseUrl, body: request, api: Api.IncontrolV2 });
            formTemplates.value.push(data);
            toast.success('TemplateCreated');
            return data;
        } catch (error) {
            return handleAxiosError(error, [], 'Vragenlijst sjabloon konden niet opgeslagen worden');
        }
    }

    return {
        formTemplates,
        currentFormTemplate,
        getAll,
        create
    };
});
